<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="dragActive"
       v-show="!dragTargetHover"
       :id="$attrs['id']"
       :class="[{'overlay--transfer--dark-mode': darkMode}]"
       class="overlay--transfer"
       @dragenter="dragenter($event)"
       @dragleave="dragleave($event)"
       @dragover="dragover($event)"
       @drop="drop($event)">
    <div class="overlay--transfer__inner">
      <icon icon="copy-down" />
    </div>
  </div>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last } from 'lodash';

export default {
  name: 'TransferOverlay',
  mixins: [HotelmeisterMixin],

  props: ['darkMode'],

  data: function () {
    return {
      dragActive: false,
      dragTargetHover: false,
    };
  },

  created: function () {
    this.$serviceBus.$on('transaction.dragstart', () => {
      this.dragActive = true;
    });
    this.$serviceBus.$on('transaction.dragend', () => {
      this.dragActive = false;
      this.dragTargetHover = false;
    });
    this.$serviceBus.$on('transaction.dragenter', () => {
      this.dragTargetHover = true;
    });
    this.$serviceBus.$on('transaction.dragleave', () => {
      // disabled because dragleave on transfer overlay is triggered every time transfer overlay gets hidden
      // this.dragTargetHover = false;
    });
  },

  methods: {
    dragleave($event, folio) {
      $event.stopPropagation();
    },
    drop($event, folio) {
    },
    dragover($event, folio) {
      if (this.dragTargetHover === false) {
        this.$serviceBus.$emit('transaction.dragenter');
      }
      $event.preventDefault();
      $event.stopPropagation();
    },
    dragenter($event, folio) {
      this.$serviceBus.$emit('transaction.dragenter');
      $event.preventDefault();
      $event.stopPropagation();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .overlay--transfer {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    opacity: 1;
    // pointer-events: none;
    z-index: 2;

    // mix-blend-mode: multiply;
    background: rgba($lightgray, 0.7);
    // backdrop-filter: blur(2px);
    @include icon-color(rgba($black, 1));
    // backdrop-filter: blur(2px);
    padding: 0.5rem;

    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;

    &__inner {
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-items: center;
      align-items: center;
      justify-content: center;
      align-content: center;
      flex: 1;
      border: 0.3rem dashed $mint;
      border-radius: 0.5rem;
    }

    .hm-icon {
      width: 120px;
      height: 120px;
      padding: 2rem;
      border-radius: 50%;
      // border: 4px solid $middlegray;
    }

    &--dark-mode {
      background: rgba($nav_item_bg, 0.65);
      .hm-icon {
        // border: 4px solid $white;
      }
      @include icon-color(rgba($white, 1));
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/lib/folios/TransferOverlay.vue